import CreditChartPresenter from "./CreditChart/CreditChartPresenter";
import LastCreditPresenter from "./CreditChart/LastCreditPresenter";

export const CreditChart = CreditChartPresenter;
export const LastCreditValue = LastCreditPresenter;